var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: { "user-button-container": !_vm.nameIsDisable } }, [
    _vm.showAvatar
      ? _c("img", {
          staticClass: "avatar ma-0",
          style: { width: _vm.avatarWidth, height: _vm.avatarHeight },
          attrs: { src: _vm.avatar }
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.nameIsDisable
      ? _c(
          "div",
          {
            staticClass: "text-container",
            class: { "with-avatar": _vm.showAvatar },
            on: {
              click: function($event) {
                return _vm.$emit("click")
              }
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "name-container",
                class: { "user-info-text": _vm.locationInApp === "hub" },
                style: { "font-size": _vm.nameSize }
              },
              [
                !_vm.showAvatar
                  ? _c("span", { staticClass: "helloSpan" }, [
                      _vm._v(_vm._s(_vm.$t("Hello")) + ", ")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { staticClass: "fullName" }, [
                  _vm._v(_vm._s(_vm.name))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "shortName" }, [
                  _vm._v(_vm._s(_vm.firstName))
                ])
              ]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3bd1b35c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bd1b35c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/_Molecules/UserButton.vue
// module id = null
// module chunks = 